// extracted by mini-css-extract-plugin
export default {"container":"SplashPreloader_container__kolZD","content":"SplashPreloader_content__N8bSM","loader":"SplashPreloader_loader__s6AGS"};